// This component is First tab of Application form // To get basic contact and
address details
<template>
  <div class="bg-gray-50 shadow px-4 py-5 sm:rounded sm:p-6" v-bind:class="{ 'model-open': showDeleteModal }">
    <div class="md:grid md:grid-cols-2 md:gap-6 sm:px-6">
      <div class="md:col-span-1">
        <h3 class="text-lg font-sans font-medium leading-6 text-gray-900">
          PRIMARY DETAILS
        </h3>
        <p class="mt-1 text-sm text-gray-500">
          Please enter your name, contact(s) information, and address(es) as you
          wish them to appear in our attorney directory.
        </p>
      </div>
      <div class="mt-5 md:mt-0 md:col-span-2">
        <form @submit.prevent="submitApplication" novalidate class="space-y-6">
          <div class="col-span-6 sm:col-span-3">
            <div class="shadow sm:rounded-md sm:overflow-hidden 2">
              <div class="bg-white py-6 px-4 space-y-6 sm:p-6">
                <div class="grid xl:grid-cols-6 grid-cols-2 xl:gap-4 gap-3">
                  <div class="col-span-6 sm:col-span-1">
                    <label class="block text-sm font-medium text-gray-900" for="date_admitted_to_bar">Salutations
                    </label>
                    <AutoComplete class="h-10 pt-1" forceSelection :dropdown="true" readonly
                      :class="{ 'border-red-400': v$.form.salutation.$error }" v-model="form.salutation"
                      :suggestions="salutations" @complete="searchAutocomplete($event, 'salutation')" field="name" />
                    <!-- <div
                      class="text-red-600 mt-1 text-sm"
                      v-for="(error, index) in v$.form.salutation.$errors"
                      :key="index"
                    >
                      <div v-if="error.$validator == 'required'">
                        {{ error.$message }}
                      </div>
                    </div> -->
                  </div>
                  <div class="col-span-6 sm:col-span-2">
                    <text-input label="First Name" :class="{ 'border-red-400': v$.form.first_name.$error }"
                      v-bind:value="form.first_name" id="first_name" :required="true"
                      v-on:keyup="form.first_name = $event.target['value']"
                      helptext="Enter your first name"></text-input>
                    <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.first_name.$errors"
                      :key="index">
                      <div v-if="error.$validator == 'required'">
                        {{ error.$message }}
                      </div>
                    </div>
                  </div>
                  <div class="col-span-6 sm:col-span-1">
                    <text-input label="Middle Name" v-bind:value="form.middle_name" id="middle_name"
                      :class="{ 'border-red-400': v$.form.middle_name.$error }"
                      v-on:keyup="form.middle_name = $event.target['value']"
                      helptext="Middle name or initails"></text-input>
                    <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.middle_name.$errors"
                      :key="index">
                      <div v-if="error.$validator == 'required'">
                        {{ error.$message }}
                      </div>
                    </div>
                  </div>
                  <div class="col-span-6 sm:col-span-2">
                    <text-input label="Last Name" :required="true"
                      :class="{ 'border-red-400': v$.form.last_name.$error }" v-bind:value="form.last_name"
                      id="last_name" v-on:keyup="form.last_name = $event.target['value']"
                      helptext="Enter your last name"></text-input>
                    <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.last_name.$errors"
                      :key="index">
                      <div v-if="error.$validator == 'required'">
                        {{ error.$message }}
                      </div>
                    </div>
                  </div>
                  <div class="col-span-6 sm:col-span-3">
                    <text-input label="Name of Firm" :class="{ 'border-red-400': v$.form.firm_name.$error }"
                      v-bind:value="form.firm_name" id="firm_name"
                      v-on:keyup="form.firm_name = $event.target['value']"></text-input>
                    <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.firm_name.$errors"
                      :key="index">
                      <div v-if="error.$validator == 'required'">
                        {{ error.$message }}
                      </div>
                    </div>
                  </div>
                  <div class="col-span-6 sm:col-span-1">
                    <text-input label="Office Hours" type="text"
                      :class="{ 'border-red-400': v$.form.office_hours.$error }" v-bind:value="form.office_hours"
                      id="office_hours" v-on:keyup="form.office_hours = $event.target['value']"></text-input>
                    <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.office_hours.$errors"
                      :key="index">
                      <div v-if="error.$validator == 'required'">
                        {{ error.$message }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="" v-for="(contact, i) in form.contacts" :key="i">
                  <!-- START PRIMARY CONTACT SECTION -->
                  <div class="flex cobalt-bg-color items-center justify-between flex-wrap sm:flex-nowraps"
                    v-if="i == 0">
                    <div class="m-4">
                      <h3 class="text-lg leading-6 font-medium text-[#1f3341]">
                        Primary Contact
                      </h3>
                    </div>

                    <div class="mr-4 flex-shrink-0">
                      <button type="button" @click="add_contact()"
                        class="relative inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded shadow-sm text-white barley-btn focus:outline-none focus:ring-2 focus:ring-offset-2">
                        + Add Contact
                      </button>
                    </div>
                  </div>
                  <div class="flex cobalt-bg-color items-center justify-between flex-wrap sm:flex-nowraps"
                    v-if="i != 0">
                    <div class="m-4">
                      <h3 class="text-lg leading-6 font-medium text-[#1f3341]">
                        Secondary Contact
                      </h3>
                    </div>

                    <div class="mr-4 flex-shrink-0">
                      <button type="button" @click="ConfirmContactDelete(i)"
                        class="inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded shadow-sm text-white bg-red-500 hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500">
                        + Remove Contact
                      </button>
                    </div>
                  </div>
                  <h6 v-if="i == 0" class="mt-2 text-sm">
                    <span class="text-red-500">*</span>
                    If you need to update your primary email. Please get in
                    touch with U.S. Legal Services Provider Relations team.
                  </h6>
                  <div class="form-group grid xl:grid-cols-6 grid-cols-3 xl:gap-6 gap-2 mt-2">
                    <div class="col-span-6 sm:col-span-1" v-if="i == 0">
                      <label class="block text-sm font-medium text-gray-900 mb-1" for="type">Contact Type
                      </label>
                      <AutoComplete class="h-10" forceSelection :dropdown="true" disabled v-model="contact.type"
                        :suggestions="infoTypes" @complete="searchAutocomplete($event, 'infoTypes')" field="name" />
                    </div>
                    <div class="col-span-6 sm:col-span-1" v-if="i != 0">
                      <label class="block text-sm font-medium text-gray-900 mb-1" for="type">Contact Type..
                      </label>
                      <AutoComplete class="h-10" forceSelection :dropdown="true" disabled v-model="contact.type"
                        :suggestions="infoTypes" @complete="searchAutocomplete($event, 'infoTypes')" field="name" />
                    </div>
                    <div class="col-span-6 sm:col-span-2">
                      <text-input v-if="i == 0" :id="'name' + i" label="Name" :required="true"
                        v-bind:value="contact.name" v-on:keyup="contact.name = $event.target['value']"></text-input>
                      <text-input v-if="i != 0" :id="'name' + i" label="Name" :required="false"
                        v-bind:value="contact.name" v-on:keyup="contact.name = $event.target['value']"></text-input>
                      <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.contacts[i]?.name
                        .$errors" :key="index">
                        <div v-if="error.$validator == 'required'">
                          {{ error.$message }}
                        </div>
                      </div>
                    </div>
                    <div class="col-span-6 sm:col-span-2">
                      <text-input :id="'email' + i" label="Email" :required="true" :disabled="i == 0 &&
                          contact.old_email != '' &&
                          contact.old_email != null
                          ? true
                          : false
                        " v-if="i == 0" :class="{
                          'border-red-400': v$.form.contacts[i]?.email.$error,
                        }" v-bind:value="contact.email"
                        v-on:keyup="contact.email = $event.target['value']"></text-input>
                      <text-input v-if="i != 0" :id="'email' + i" label="Email" :required="false" :class="{
                        'border-red-400': v$.form.contacts[i]?.email.$error,
                      }" v-bind:value="contact.email"
                        v-on:keyup="contact.email = $event.target['value']"></text-input>
                      <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.contacts[i]?.email
                        .$errors" :key="index">
                        <div v-if="error.$validator == 'required'">
                          {{ error.$message }}
                        </div>
                        <div v-if="error.$validator == 'email'">
                          Please enter valid email
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group grid xl:grid-cols-6 grid-cols-2 xl:gap-6 gap-2 mt-2">
                    <div class="col-span-6 sm:col-span-1">
                      <label class="block text-sm font-medium text-gray-900">Office Telephone
                        <span class="text-red-500" v-if="i == 0">*</span></label>
                      <InputMask mask="(999)999-9999"
                        class="mt-1 block w-full h-10 border border-gray-300 rounded-sm shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        placeholder="(111)222-3333" :class="{
                          'border-red-400': v$.form.contacts[i]?.phone.$error,
                        }" v-model="contact.phone" />
                      <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.contacts[i]?.phone
                        .$errors" :key="index">
                        <div v-if="error.$validator == 'required'">
                          {{ error.$message }}
                        </div>
                      </div>
                    </div>
                    <div class="col-span-6 sm:col-span-1">
                      <text-input :id="'ext' + i" label="Extension" :class="{
                        'border-red-400': v$.form.contacts[i]?.ext.$error,
                      }" v-bind:value="contact.ext" v-on:keyup="contact.ext = $event.target['value']"></text-input>
                    </div>
                    <div class="col-span-6 sm:col-span-1">
                      <text-input :id="'fax' + i" label="Fax" v-bind:value="contact.fax" :class="{
                        'border-red-400': v$.form.contacts[i]?.fax.$error,
                      }" v-on:keyup="contact.fax = $event.target['value']"></text-input>
                    </div>
                    <div class="col-span-6 sm:col-span-1">
                      <label class="block text-sm font-medium text-gray-900">Cell Phone</label>
                      <InputMask
                        class="mt-1 h-10 block w-full border border-gray-300 rounded-sm shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        mask="(999)999-9999" placeholder="(111)222-3333" :class="{
                          'border-red-400': v$.form.contacts[i]?.cell.$error,
                        }" v-model="contact.cell" />
                    </div>
                  </div>
                </div>
                <!-- END PRIMARY CONTACT SECTION -->
                <div class="" v-for="(address, ind) in form.addresses" :key="ind">
                  <!-- START PRIMARY ADDRESS SECTION -->
                  <div class="flex cobalt-bg-color items-center justify-between flex-wrap sm:flex-nowraps"
                    v-if="ind == 0">
                    <div class="m-4">
                      <h3 class="text-lg leading-6 font-medium text-[#1f3341]">
                        Primary Address
                      </h3>
                    </div>

                    <div class="mr-4 flex-shrink-0">
                      <button type="button" @click="add_address()"
                        class="relative inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded shadow-sm text-white barley-btn focus:outline-none focus:ring-2 focus:ring-offset-2">
                        + Add Address
                      </button>
                    </div>
                  </div>
                  <div class="flex cobalt-bg-color items-center justify-between flex-wrap sm:flex-nowraps"
                    v-if="ind != 0">
                    <div class="m-4">
                      <h3 class="text-lg leading-6 font-medium text-white">
                        Secondary Address
                      </h3>
                    </div>

                    <div class="mr-4 flex-shrink-0">
                      <button type="button" @click="ConfirmDelete(ind)"
                        class="relative inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded shadow-sm text-white bg-red-500 hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500">
                        + Remove Address
                      </button>
                    </div>
                  </div>
                  <div>
                    <div class="form-group grid xl:grid-cols-6 grid-cols-1 xl:gap-6 gap-0 mt-2">
                      <div class="col-span-6 sm:col-span-1">
                        <label class="block text-sm font-medium text-gray-900 mt-2" for="type">Address Type <span
                            class="text-red-500">*</span>
                        </label>
                        <div class="form-group mt-1" v-if="ind == 0">
                          <AutoComplete class="h-10" forceSelection :dropdown="true" disabled v-model="address.type"
                            :suggestions="infoTypes" @complete="searchAutocomplete($event, 'infoTypes')" field="name" />
                        </div>

                        <div class="form-group mt-2" v-if="ind != 0">
                          <AutoComplete class="h-10" forceSelection :class="{
                            'border-red-400':
                              v$.form.addresses[ind]?.type.$error,
                          }" :dropdown="true" disabled v-model="address.type" :suggestions="infoTypes"
                            @complete="searchAutocomplete($event, 'infoTypes')" field="name" />
                          <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.addresses[ind]?.type
                            .$errors" :key="index">
                            <div v-if="error.$validator == 'required'">
                              {{ error.$message }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group mt-2 col-span-6 sm:col-span-3">
                        <label class="block text-sm font-medium text-gray-900" for="date_admitted_to_bar">Address (line
                          1) <span class="text-red-500">*</span>
                        </label>
                        <vue-google-autocomplete class="mt-1" :id="'address_' + ind" :ref="'address_' + ind"
                          :types="['address', 'geocode', '(region)']" :class="{
                            'border-red-400':
                              v$.form.addresses[ind]?.address1.$error,
                          }" v-model="address.address1"
                          classname="w-full text-black border border-barley rounded py-2 px-4 mb-3" v-on:placechanged="
                            getAddressData($event, 'address1', ind)
                            ">
                        </vue-google-autocomplete>
                        <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.addresses[ind]
                          ?.address1.$errors" :key="index">
                          <div v-if="error.$validator == 'required'">
                            {{ error.$message }}
                          </div>
                        </div>
                      </div>

                      <div class="form-group mt-2 col-span-6 sm:col-span-2">
                        <text-input :id="'address2' + ind" label="Address (line 2)" v-bind:value="address.address2"
                          v-on:keyup="address.address2 = $event.target['value']"></text-input>
                      </div>
                    </div>

                    <div class="form-group grid xl:grid-cols-6 grid-cols-2 xl:gap-6 gap-2 mt-2">
                      <!-- city -->
                      <div class="col-span-6 sm:col-span-1">
                        <text-input :id="'city' + ind" label="City" :required="true" :class="{
                          'border-red-400': v$.form.addresses[ind]?.city.$error,
                        }" v-bind:value="address.city"
                          v-on:keyup="address.city = $event.target['value']"></text-input>
                        <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.addresses[ind]?.city
                          .$errors" :key="index">
                          <div v-if="error.$validator == 'required'">
                            {{ error.$message }}
                          </div>
                        </div>
                      </div>

                      <div class="col-span-6 sm:col-span-1">
                        <text-input label="State" :id="'state' + ind" :required="true" :class="{
                          'border-red-400':
                            v$.form.addresses[ind]?.state.$error,
                        }" v-bind:value="address.state"
                          v-on:keyup="address.state = $event.target['value']"></text-input>
                        <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.addresses[ind]?.state
                          .$errors" :key="index">
                          <div v-if="error.$validator == 'required'">
                            {{ error.$message }}
                          </div>
                        </div>
                      </div>
                      <div class="col-span-6 sm:col-span-1">
                        <text-input :id="'country' + ind" label="Country" v-bind:value="address.country"
                          v-on:keyup="address.country = $event.target['value']"></text-input>
                      </div>
                      <div class="col-span-6 sm:col-span-1">
                        <text-input label="Zip" :id="'zip' + ind" :required="true" @change="getCountry(ind)" :class="{
                          'border-red-400': v$.form.addresses[ind]?.zip.$error,
                        }" v-bind:value="address.zip" v-on:keyup="address.zip = $event.target['value']">
                        </text-input>
                        <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.addresses[ind]?.zip
                          .$errors" :key="index">
                          <div v-if="error.$validator == 'required'">
                            {{ error.$message }}
                          </div>
                        </div>
                      </div>

                      <div class="col-span-6 sm:col-span-1">
                        <text-input :id="'county' + ind" label="County" disabled v-bind:value="address.county"
                          v-on:keyup="address.county = $event.target['value']"></text-input>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- END PRIMARY ADDRESS SECTION -->
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <confirm-popup :showDeleteModal="showDeleteModal" title="Delete" short_msg="Are you sure?"
      msg=" Do you really want to delete this address? This process cannot be undone." @click="cancelModal()"
      @remove="remove_address()"></confirm-popup>

    <confirm-popup :showDeleteModal="showContactDeleteModal" title="Delete" short_msg="Are you sure?"
      msg=" Do you really want to delete this contact? This process cannot be undone." @click="cancelModal()"
      @remove="remove_contact()"></confirm-popup>
  </div>
</template>
<script>
import VueGoogleAutocomplete from "vue-google-autocomplete"; //For address autocomplete from google
import TextInput from "../Layout/Form/TextInput.vue"; //reusable Input field
import ConfirmPopup from "../Layout/Modals/ConfirmPopup.vue"; // resuable delete confirm popup
import useVuelidate from "@vuelidate/core"; // For validation
import { required } from "@vuelidate/validators"; // For validation
import { helpers } from "vuelidate/lib/validators"; // custom validator for email
const email = helpers.regex(
  "email",
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}$/
);
import InputMask from "primevue/inputmask"; // Validation mask
import { mapState } from "vuex"; //Import store varibles using mapState
import moment from "moment-timezone"; // ilbrary for date costomization

export default {
  name: "AppPrimary",
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  props: ["forms"],
  data: function () {
    // Static variables for this component
    return {
      form: this.forms,
      sizes: ["lg", "md", "sm"],
      showDeleteModal: false,
      showContactDeleteModal: false,
      deleteIndex: "",
      deleteContactIndex: "",
      salutations: [
        { id: 0, name: "Mr" },
        { id: 1, name: "Mrs" },
        { id: 2, name: "MS" },
      ],
      attorney_types: [
        { id: "FAM", name: "Family Defender (FAM)" },
        { id: "CDL", name: "CDL Defender (CDL)" },
        { id: "REF", name: "Referral (REF)" },
      ],
      infoTypes: [
        { id: 0, name: "PRIMARY" },
        { id: 1, name: "SECONDARY" },
      ],
    };
  },
  validations() {
    //For Dynamic Validation based on Dynamic form fields
    let addresses = [];
    let contacts = [];
    for (let index = 0; index < this.form?.addresses?.length; index++) {
      addresses.push({
        type: { required },
        address1: { required },
        city: { required },
        state: { required },
        zip: { required },
      });
    }
    for (let index = 0; index < this.form?.contacts?.length; index++) {
      if (index == 0) {
        contacts.push({
          email: { email, required },
          name: { required },
          fax: {},
          cell: {},
          phone: { required },
          ext: {},
        });
      } else {
        contacts.push({
          email: {},
          name: {},
          fax: {},
          cell: {},
          phone: {},
          ext: {},
        });
      }
    }
    return {
      form: {
        first_name: { required },
        last_name: { required },
        middle_name: {},
        office_hours: {},
        salutation: {},
        firm_name: {},
        addresses: addresses,
        contacts: contacts,
      },
    };
  },
  components: {
    VueGoogleAutocomplete,
    TextInput,
    ConfirmPopup,
    InputMask,
  },
  mounted() {
    if (!this.att_user?.data || this.att_user == undefined) {
      let Data = this.leadData.result.lead[0];
      this.form.lead_id = Data.id;
      if (!this.tempAttData.is_attorney_exist) {
        this.form.first_name = Data.firstname;
        this.form.last_name = Data.lastname;
        setTimeout(() => {
          this.form.emailAddress = Data.email; // HubSpot uses `email`
          setTimeout(() => {
              this.form.addresses[0].address1 = Data.address; // keep form in sync
                      document.getElementById("address_0").value = Data.address;
          }, 500);

          this.form.addresses[0].city = Data.city;
          const stateMap = {
            "Alabama": "AL",
            "Alaska": "AK",
            "Arizona": "AZ",
            "Arkansas": "AR",
            "California": "CA",
            "Colorado": "CO",
            "Connecticut": "CT",
            "Delaware": "DE",
            "Florida": "FL",
            "Georgia": "GA",
            "Hawaii": "HI",
            "Idaho": "ID",
            "Illinois": "IL",
            "Indiana": "IN",
            "Iowa": "IA",
            "Kansas": "KS",
            "Kentucky": "KY",
            "Louisiana": "LA",
            "Maine": "ME",
            "Maryland": "MD",
            "Massachusetts": "MA",
            "Michigan": "MI",
            "Minnesota": "MN",
            "Mississippi": "MS",
            "Missouri": "MO",
            "Montana": "MT",
            "Nebraska": "NE",
            "Nevada": "NV",
            "New Hampshire": "NH",
            "New Jersey": "NJ",
            "New Mexico": "NM",
            "New York": "NY",
            "North Carolina": "NC",
            "North Dakota": "ND",
            "Ohio": "OH",
            "Oklahoma": "OK",
            "Oregon": "OR",
            "Pennsylvania": "PA",
            "Rhode Island": "RI",
            "South Carolina": "SC",
            "South Dakota": "SD",
            "Tennessee": "TN",
            "Texas": "TX",
            "Utah": "UT",
            "Vermont": "VT",
            "Virginia": "VA",
            "Washington": "WA",
            "West Virginia": "WV",
            "Wisconsin": "WI",
            "Wyoming": "WY"
          };
    setTimeout(() => {
  const ref = this.$refs["address_0"];
  if (ref) {
    // If it's an array (v-for), take first element
    const autocompleteComponent = Array.isArray(ref) ? ref[0] : ref;
      autocompleteComponent.update(this.form.addresses[0].address1);
  }
}, 500);

          // Convert full state name from HubSpot to abbreviation
          const stateShort = stateMap[Data.state] || Data.state;

          // Now set in your form
          this.form.addresses[0].state = stateShort;

          this.form.addresses[0].zip = Data.zip;
          this.form.addresses[0].country = Data.country;

          this.form.contacts[0].name = Data.firstname + " " + Data.lastname;
          this.form.contacts[0].old_email = this.form.contacts[0].email;
          this.form.contacts[0].fax = Data.fax;

          if (Data.phone != "" && Data.phone != null) {
            this.form.contacts[0].phone = this.formatPhoneUS(Data.phone);
          }
          if (Data.mobilephone != "" && Data.mobilephone != null) {
            this.form.contacts[0].cell = this.formatPhoneUS(Data.mobilephone);
          }

          // phone extension is not default in HubSpot → must create a custom field
          this.form.contacts[0].ext = Data.phoneNumberExtension || "";

          this.form.contacts[0].email = Data.email;
        }, 1000);
      } else {
        for (let index = 0; index < this.form?.addresses?.length; index++) {
          setTimeout(() => {
            if (
                    this.$refs &&
                    this.$refs["address_" + index] &&
                    typeof this.$refs["address_" + index].update === "function"
                  ) {
                    this.$refs["address_" + index].update(
                      this.form.addresses[index].address1
                    );
                  }
          }, 1000);
        }
      }
      let keys = Object.keys(Data);
      this.form.lead.hs_object_id = Data.id;
      keys.forEach((key) => {
        var currentDate = new Date();
        currentDate = moment(currentDate).tz("US/Eastern").format("YYYY-MM-DD");
        if (key.includes("attorney_join_or_decline") || key.includes("did_attorney_join_or_decline_")) {
          this.form.lead[key] = "Joined";
        }
        if (key.includes("attorney_status_in_member_system")) {
          this.form.lead[key] = "Pending";
        }
        if (key.includes("date_joined_or_declined_")) {
          this.form.lead[key] = currentDate;
        }
        if (key.includes("date_application_received_by_usl_")) {
          this.form.lead[key] = currentDate;
        }
        if (
          key.includes("family_defender_attorney_") &&
          !key.includes("family_defender_attorney_application_requested_")
        ) {
          if (Data[key] != "" && Data[key] != null && Data[key] == "Yes") {
            this.form.attorney_type.push("FAM");
          }
        }
        if (
          key.includes("referral_attorney_") ||
          key.includes("contingent_fee_attorney_") ||
          key.includes("discounted_rate_attorney_")
        ) {
          if (Data[key] != "" && Data[key] != null && Data[key] == "Yes") {
            this.form.attorney_type.push("REF");
          }
        }
        if (
          key.includes("cdl_attorney_") ||
          key.includes("family_defender_attorney_application_requested_")
        ) {
          if (Data[key] != "" && Data[key] != null && Data[key] == "Yes") {
            this.form.attorney_type.push("CDL");
          }
        }
      });
    } else {
      for (let index = 0; index < this.form?.addresses?.length; index++) {
        setTimeout(() => {
          document.getElementById("address_" + index).value =
            this.form.addresses[index].address1;
          // this.$refs["address_" + index]?.update(
          //   this.form.addresses[index].address1
          // );
        }, 1000);
      }
    }
  },
  //to fetch variable data from central store

  computed: mapState([
    "leadData",
    "att_user",
    "profile_data",
    "address_county",
    "tempAttData",
  ]),
  created() {
    this.$store.watch(
      () => this.$store.state.profile_data,
      (value) => {
        if (value != null) {
          if (this.att_user?.data && this.att_user != undefined) {
            // If already sbumitted application and comes to update
            //get all contacts info
            this.form.contacts = this.profile_data?.contacts;
            this.form?.contacts?.forEach((element) => {
              if (element.type == "PRIMARY" || element.type == "Primary") {
                element.type = { id: 0, name: "PRIMARY" };
              } else {
                element.type = { id: 1, name: element.type };
              }
            });
            this.form.contacts[0].old_email = this.form.contacts[0].email;
            //get all address info
            this.form.addresses = this.profile_data?.addresses;
            for (let index = 0; index < this.form?.addresses?.length; index++) {
              if (typeof this.form.addresses[index].type != "object") {
                if (
                  this.form.addresses[index].type == "PRIMARY" ||
                  this.form.addresses[index].type == "Primary"
                ) {
                  this.form.addresses[index].type = { id: 0, name: "PRIMARY" };
                } else {
                  this.form.addresses[index].type = {
                    id: 1,
                    name: this.form.addresses[index].type,
                  };
                }

                setTimeout(() => {
                  if (
                    this.$refs &&
                    this.$refs["address_" + index] &&
                    typeof this.$refs["address_" + index].update === "function"
                  ) {
                    this.$refs["address_" + index].update(
                      this.form.addresses[index].address1
                    );
                  }
                }, 100);
              }
            }
            //get basic information
            this.form.id = this.profile_data?.id;
            this.form.first_name = this.profile_data?.first_name;
            this.form.last_name = this.profile_data?.last_name;
            this.form.middle_name = this.profile_data?.middle_name;
            this.form.firm_name = this.profile_data?.firm_name;
            this.form.office_hours = this.profile_data?.office_hours;
            this.salutations.forEach((element) => {
              if (element.name == this.profile_data?.salutation) {
                this.form.salutation = element;
              }
            });

            if (typeof this.profile_data?.attorney_type == "string") {
              this.form.attorney_type =
                this.profile_data?.attorney_type?.split(",");
            }
          }
        }
      }
    );
  },
  methods: {
    formatPhoneUS(phone) {
      // remove everything except digits
      let digits = ('' + phone).replace(/\D/g, '');

      // remove leading country code (+1)
      if (digits.length > 10 && digits.startsWith('1')) {
        digits = digits.slice(1);
      }

      // pad with zeros if less than 10
      while (digits.length < 10) {
        digits = digits + "0";
      }

      // only take first 10 digits
      digits = digits.slice(0, 10);

      return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    },
    //After select address, autofill city,state,county, zip from address
    getAddressComponent(addressComponents, type) {
      const component = addressComponents.find((comp) =>
        comp.types.includes(type)
      );
      return component ? component.long_name : null;
    },
    getAddressData: function (addressData, field, index) {
      
      this.$nextTick(() => {
        const addressRef = this.$refs["address_" + index];
        let autocompleteText = "";

        if (Array.isArray(addressRef)) {
          autocompleteText = addressRef[0]?.autocompleteText || "";
        } else {
          autocompleteText = addressRef?.autocompleteText || "";
        }

        // Split into comma-separated parts
        const parts = autocompleteText.split(",").map(part => part.trim());

        // Remove last 2–3 parts (country, state, city)
        const cleanedParts = parts.slice(0, parts.length - 3);

        // Fallback: If removing 3 parts leaves nothing, use first 2
        const addressLine1 =
          cleanedParts.length > 0 ? cleanedParts.join(", ") : parts.slice(0, 2).join(", ");

        // ✅ Set final address1
        this.form.addresses[index].address1 = addressLine1;

        // Clear address2
        this.form.addresses[index].address2 = "";

        // Structured fields
        this.form.addresses[index].city = addressData.locality || addressData.city || "";
        this.form.addresses[index].state = addressData.administrative_area_level_1 || addressData.state || "";
        this.form.addresses[index].zip = addressData.postal_code || "";
        this.form.addresses[index].county = addressData.administrative_area_level_2 || "";

        const countryText = addressData.country;
        this.form.addresses[index].country =
          typeof countryText === "string" && countryText.length > 1 && countryText !== "0"
            ? countryText
            : "United States";

        if (!this.form.addresses[index].county) {
          this.$store
            .dispatch("getAddressCounty", {
              zip: this.form.addresses[index].zip,
              city: this.form.addresses[index].city,
              state: this.form.addresses[index].state,
            })
            .then(() => {
              this.form.addresses[index].county = this.address_county;
            });
        }
      });
    },

    // filter data in autocomplete dropdown
    searchAutocomplete: function (event, field) {
      if (field == "salutation") {
        if (!event.query.trim().length) {
          this.salutations = [...this.salutations];
        } else {
          this.salutations = this.salutations.filter((item) => {
            return item.name
              .toLowerCase()
              .startsWith(event.query.toLowerCase());
          });
        }
      } else if (field == "infoTypes") {
        if (!event.query.trim().length) {
          this.infoTypes = [...this.infoTypes];
        } else {
          this.infoTypes = this.infoTypes.filter((item) => {
            return item.name
              .toLowerCase()
              .startsWith(event.query.toLowerCase());
          });
        }
      }
    },
    // add more contact
    add_contact: function () {
      this.form.contacts.push({
        name: "",
        type: { id: 1, name: "SECONDARY" },
        email: "",
        fax: "",
        cell: "",
        phone: "",
        ext: "",
      });
    },
    getCountry: function (index) {
      this.$store.dispatch("getAddressCounty", {
        zip: this.form.addresses[index].zip,
        city: this.form.addresses[index].city,
        state: this.form.addresses[index].state,
      });
      setTimeout(() => {
        this.form.addresses[index].county = this.address_county;
      }, 1100);
    },
    //add more address
    add_address: function () {
      this.form.addresses.push({
        type: { id: 1, name: "SECONDARY" },
        address1: "",
        address2: "",
        city: "",
        state: "",
        country: "",
        county: "",
        zip: "",
      });
      this.v$.$touch();
      console.log(this.v$.form.addresses[0].address1);
      if (this.v$.$invalid) return;
    },
    // Open confirmation popup for delete address
    ConfirmDelete: function (index) {
      this.showDeleteModal = true;
      this.deleteIndex = index;
    },
    // Open confirmation popup for delete contact
    ConfirmContactDelete: function (index) {
      this.showContactDeleteModal = true;
      this.deleteContactIndex = index;
    },
    // On cancel in popup
    cancelModal: function () {
      this.showDeleteModal = false;
      this.showContactDeleteModal = false;
    },
    // remove address from address array
    remove_address: function () {
      if (
        this.form.addresses[this.deleteIndex + 1]?.address1 != undefined &&
        this.form.addresses[this.deleteIndex + 1]?.address1 != null
      ) {
        if (this.$refs["address_" + this.deleteIndex].update) {
          this.$refs["address_" + this.deleteIndex].update(
            this.form.addresses[this.deleteIndex + 1].address1
          );
        } else if (this.$refs["address_" + this.deleteIndex][0].update) {
          this.$refs["address_" + this.deleteIndex].update(
            this.form.addresses[this.deleteIndex + 1][0].address1
          );
        }
      } else {
        if (this.$refs["address_" + this.deleteIndex].clear) {
          this.$refs["address_" + this.deleteIndex].clear();
        } else if (this.$refs["address_" + this.deleteIndex][0].update) {
          this.$refs["address_" + this.deleteIndex][0].clear();
        }
      }
      this.form.addresses.splice(this.deleteIndex, 1);
    },
    // remove contact from contact array
    remove_contact: function () {
      this.form.contacts.splice(this.deleteContactIndex, 1);
    },
    //submit primary step and validate form
    submitApplication: function () {
      this.v$.form.$touch(this.v$.form.errors);
      console.log(this.v$.form);
      if (this.v$.form.$pending || this.v$.form.$error) return;
    },
  },
};
</script>
